import { readJsonStream } from '@atlassian/conversation-assistant';

export const fetchStream = async <T>(path: string, options: RequestInit) => {
    const response = await fetch(path, options);
    return readJsonStream<T>(response);
};
